import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// A mouse wheel over a focused number box would change its figure. Leave the box, so the wheel only scrolls the page.
document.addEventListener(
  'wheel',
  () => {
    const active = document.activeElement;
    if (active instanceof HTMLInputElement && active.type === 'number') active.blur();
  },
  { passive: true, capture: true }
);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
